const FEET_TO_METER_RATIO = 0.3048;
/**
 * Convert sqm to sqft
 */
export function areaMetricToImperial(size: number, exponent: number = 2): number {
  return Math.round(size / Math.pow(FEET_TO_METER_RATIO, exponent));
}
